const Timeline = (state = [], action) => {
    switch (action.type) {
        case 'TIME_LINE_API_SUCCESS':
            return action?.payload?.res?.data
            case 'ADD_COMMENT_SUCCESS':
                return [action?.payload?.res?.data, ...state]          
        default:
            return state
    }
}
export default Timeline